import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import store from '@/store';

// 查询设计项目列表
export const queryInspectionPages: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setInspectionPages', { ...state.inspectionPage, loading: true });
    const res: IPageData = await $http.post('/v1/design/acceptance/workinglist', payload);
    const { list: data, total, pageNum, pageSize } = res;
    commit('setInspectionPages', { data, total, pageNum, pageSize });
  } catch (e) {
    commit('setInspectionPages', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询设计项目详情
export const queryInspectionDetail: IActionFn<IModuleState> = async ({ commit }, id) => {
  try {
    commit('setInspectionDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/design/acceptance/${id}/detail`);
    commit('setInspectionDetail', { data: res });
  } catch (e) {
    commit('setInspectionDetail', { data: null });
  }
};

// 查询反馈信息列表
export const queryFeedbackList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFeedbackList', { ...state.feedbackList, loading: true });
    const res = await $http.post('/v1/design/acceptance/note/list', payload);
    commit('setFeedbackList', { data: res });
  } catch (e) {
    commit('setFeedbackList', { data: [] });
  }
};

// 新增设计项目(改为了邀请制，所以暂时没有新增功能)
export const addInspection: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/design/acceptance/create', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 编辑设计项目(基本信息和专案组一起修改)
export const editInspection: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/design/acceptance/modify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑设计项目的基本信息(不改专案组)
export const editInspectionDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/design/acceptance/modifyDetail', payload);
    // 保存成功后查询项目详情
    const res = await $http.get(`/v1/design/acceptance/${payload.id}/detail`);
    commit('setInspectionDetail', { data: res });
    store.commit('common/setToast', { visible: true, text: '修改成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除设计项目(改为了邀请制，所以暂时没有删除功能)
export const deleteInspection: IActionFn<IModuleState> = async ({ commit, state }, ids) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    const params = { ids };
    const res: any = await $http.post('/v1/design/acceptance/delete', params, { ignoreCode: [210] });
    if (res?.rtnCode === 210) {
      store.commit('common/setToast', { visible: true, text: '数据校验错误' });
    }
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 终止设计项目
export const stopInspection: IActionFn<IModuleState> = async ({ commit, state }, id) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    const params = { id };
    const res: any = await $http.post('/v1/design/acceptance/accept', params, { ignoreCode: [210] });
    if (res?.rtnCode === 210) {
      store.commit('common/setToast', { visible: true, text: '数据校验错误' });
    }
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 为设计项目新增专案组(其实是调用编辑接口)
export const addDpgToInspection: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // 这里用编辑接口实现删除(主要就是修改dpgIds)
    await $http.post('/v1/design/acceptance/modify', payload);
    // 保存成功后查询项目详情
    const res = await $http.get(`/v1/design/acceptance/${payload.id}/detail`);
    commit('setInspectionDetail', { data: res });
    store.commit('common/setToast', { visible: true, text: '新增成功' });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 将专案组从设计项目里删除
export const deleteDpgFromInspection: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/acceptance/deletedpgs', payload);
    // 删除成功后查询项目详情
    const res = await $http.get(`/v1/design/acceptance/${payload.id}/detail`);
    commit('setInspectionDetail', { data: res });
    store.commit('common/setToast', { visible: true, text: '删除成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 将专案组交付给预约方
export const deliverDpg: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/design/acceptance/transfer', payload);
    store.commit('common/setToast', { visible: true, text: '交付成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};
